import { Dimensions } from "@faire/slate/foundation/dimensions";
import { pxOrRemToUnitlessPx } from "@faire/slate/lib/sizeUnitUtils";

export const POPOVER_ARROW_WIDTH = pxOrRemToUnitlessPx(Dimensions[4]);
export const POPOVER_ARROW_HEIGHT = pxOrRemToUnitlessPx(Dimensions[2]);
export const POPOVER_ARROW_TIP_RADIUS = 2;
export const POPOVER_ARROW_OFFSET = -pxOrRemToUnitlessPx(Dimensions[6]);
export const POPOVER_OFFSET =
  POPOVER_ARROW_HEIGHT + pxOrRemToUnitlessPx(Dimensions[1]);
export const POPOVER_FLIP_DETECTION_OFFSET = pxOrRemToUnitlessPx(Dimensions[1]);

export const POPOVER_OPEN_TRANSITION_DURATION_MS = 250;
export const POPOVER_CLOSE_TRANSITION_DURATION_MS = 100;

export const POPOVER_ALIGNMENTS = ["start", "middle", "end"] as const;
export const POPOVER_POSITIONS = ["top", "bottom", "left", "right"] as const;
export const POPOVER_FOOTER_VARIANTS = ["action", "customSlot"] as const;
